<template>
  <div class="container">
    <top-menu :current="['quote']"></top-menu>

    <div class="main-container">
      <div
        class="address-book"
        ref="addressBook"
        @touchend="handleTouchEnd"
        :style="style"
      >
        <dl
          class="letter-list"
          :class="{
            active: selectingLetter,
          }"
          @touchmove.prevent="handleTouchMove"
          @touchstart="handleTouchStart"
        >
          <dt
            v-for="item in []"
            :key="item.letter"
            @click.capture="go(item.top)"
            :data-offset="item.top"
            :class="{
              current: prevOffset == item.top,
            }"
          >
            {{ item.letter }}
            <span class="select-bubble">
              {{ item.letter }}
            </span>
          </dt>
        </dl>

        <!-- 品牌列表 -->
        <div ref="letterBlocks" style="clear: both">
          <div
            class="letter-block"
            :data-letter="item.letter"
            v-for="(item, i) in letters"
            :key="i"
          >
            <div class="letter-block-header">{{ item.letter }}</div>
            <div class="letter-block-body">
              <div
                class="letter-block-item"
                v-for="f in item.brands"
                :key="f.id"
                @click="showSeries(f.id)"
              >
                <img class="letter-block-avatar" :src="f.logo_url" />
                <span>{{ f.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="series-modal" v-if="visible" :style="seriesStyle">
          <div class="series-modal-header">
            <a-icon
              type="arrow-left"
              :style="{ fontSize: '20px' }"
              style="margin: 10px"
              @click="closeSeries"
            />
          </div>
          <div class="series-modal-body">
            <div
              class="factory"
              v-for="item in factories"
              :key="item.factory_id"
            >
              <div class="category">{{ item.factory_name }}</div>
              <ul>
                <li v-for="s in item.series" :key="s.id">
                  <router-link :to="{ name: 'Series',  params:{id: s.id}}">
                    <div class="item">
                      <img :src="s.cover_url" />
                      <h4>
                        <b>{{ s.name }}</b>
                      </h4>
                      <div class="price">{{ s.price }}</div>
                    </div>
                  </router-link>
                </li>
              </ul>
            </div>

            <div class="null" v-if="factories.length === 0">暂无</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopMenu from "@/components/Menu";

import { getBrands } from "@/api/car";
import { getSeriesByBrandId } from "@/api/car";
export default {
  data() {
    return {
      // 记录每个字母所拥有的好友、首字母以及距顶部偏移量
      // {
      //   top: number,
      //   friends: Array<FriendItem>,
      //   letter: string
      // }
      letters: [],
      prevOffset: -999,
      selectingLetter: false,
      indexBarPosX: "",

      style: "",
      brands: [],
      visible: false,
      clientHeight: 800,
      seriesStyle: "",
      factories: [],
      brandName: "",
    };
  },
  components: {
    TopMenu,
  },
  mounted() {
    const clientHeight = window.screen.height;
    this.clientHeight = clientHeight;
    this.style = "height:" + clientHeight + "px;";

    this.seriesStyle = "height:" + clientHeight + "px;";
    console.log(window.screen.height);
    // 初始化通讯录
    this.init();
    // 计算字母块所占的高度
    this.calculateLocation();
  },
  methods: {
    async init() {
      try {
        let response = await getBrands();
        this.brands = response.data;

        let letters = []; // 数据列表
        let brandMap = {}; // 每一个索引指向一个数组，这个数组存储该字母索引的朋友项
        this.brands.forEach((brand) => {
          const letter = brand.letter;
          brandMap[letter] || (brandMap[letter] = []);
          brandMap[letter].push(brand);
        });

        for (let letter in brandMap) {
          letters.push({
            letter: letter,
            top: 0,
            height: 0,
            brands: brandMap[letter],
          });
        }

        // 按首字母排序
        // 字符串比较不能用减号得出大小，返回都是NaN
        // 因此这里需要通过小于号比较
        letters.sort((a, b) => {
          return a.letter <= b.letter ? -1 : 1;
        });

        this.letters = letters;

        console.log(letters);
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * 计算位置信息
     */
    calculateLocation() {
      this.$nextTick(() => {
        // 按字母排序分开的 dom 列表
        let list = [].slice.call(this.$refs.letterBlocks.children, 0);
        console.log(list);
        // let len = list.length;
        // 对于每一个块计算距顶部的距离top 以及 通过getBoundingClientRect计算自身的高度
        // 顶部的距离 top = 上一块的高度 + 上一块的top值
        list.forEach((node, idx) => {
          if (idx !== -1) {
            this.letters[idx].top =
              idx > 0
                ? this.letters[idx - 1].top + this.letters[idx - 1].height
                : 0;
            this.letters[idx].height = node.getBoundingClientRect().height;
          }
        });

        console.log(this.letters);
      });
    },
    go(offset) {
      this.$refs.addressBook.scrollTop = offset;
    },
    handleTouchStart(e) {
      if (!this.selectingLetter) {
        this.indexBarPosX = e.touches[0].clientX;
      }
      this.selectingLetter = true;
    },
    handleTouchEnd() {
      this.prevOffset = -9999;
      this.selectingLetter = false;
    },
    handleTouchMove(e) {
      if (!this.selectingLetter) {
        return;
      }
      const x = this.indexBarPosX;
      const y = e.touches[0].clientY;
      let target = document.elementFromPoint(x, y);
      let offset = target && target.dataset && target.dataset.offset;
      if (offset && offset !== this.prevOffset) {
        this.prevOffset = offset;
        this.go(offset);
      }
    },
    showSeries(bid) {
      this.visible = true;

      getSeriesByBrandId(bid).then((response) => {
        console.log(response);
        this.factories = response.data.series;
      });
    },
    closeSeries() {
      this.visible = false;
      this.factories = [];
      this.brandName = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
   position: relative;
  top:100px;
}
.address-book {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}

.letter-list {
  position: fixed;
  top: 1.33333rem;
  right: 0.4rem;
  padding: 0.13333rem;
  color: #3f536e;
  border-radius: 0.13333rem;

  &.active {
    background: #f8f8f8;
  }

  dt {
    position: relative;
    padding: 1px 5px;
    width: 24px;
    height: 24px;
    font-weight: 400;
    color: #999cab;
    line-height: 24px;
    text-align: center;
    font-size: 11px;
    border-radius: 50%;

    &.current {
      transform: scale(1.5);

      .select-bubble {
        display: block;
      }
    }

    .select-bubble {
      position: absolute;
      top: 50%;
      right: 200%;
      transform: translateY(-50%);
      display: none;
      width: 200px;
      height: 200px;
      text-align: center;
      line-height: 200px;
      font-size: 100px;
      background: #8eaadf;
      border-radius: 50% 50%;
      color: #fff;
    }
  }
}

.letter-block {
  font-size: 1.06667rem;

  .letter-block-header {
    margin-left: 0.26667rem;
    color: #3f536e;
    height: 2rem;
    line-height: 2rem;
    font-size: 1.6rem;
    font-weight: bold;
    border-bottom: 0.01333rem solid #e8e8e8;
    padding: 0 20px;
    font-size: 14px;
    font-weight: 700;
    color: #666d7f;
    line-height: 30px;
  }

  .letter-block-item {
    padding: 0.13333rem 0.26667rem;
    line-height: 60px;
    user-select: none;
    clear: both;
    background-color: #ffffff;
    color: #111e36;

    .letter-block-avatar {
      float: left;
      border-radius: 0.13333rem;
      width: 40px;
      height: 40px;
      margin: 10px 16px 10px 20px;
    }

    &:active {
      background: #e9e9e9;
    }
  }
}

.series-modal {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #ffffff;
  z-index: 999;
  overflow: scroll;
  .series-modal-header {
    border-bottom: 1px solid #cdcdcd;
  }
  .series-modal-body {
    .null {
      font-size: 14px;
      color: #999;
      line-height: 148px;
      text-align: center;
      background-color: #fff;
    }
    .factory {
      position: relative;
      padding: 0 20px;
      font-size: 12px;
      color: #666d7f;
      line-height: 30px;
      background-image: linear-gradient(90deg, #f1f3f6, #fff);
      ul {
        margin: 0;
      }
    }
    li {
      list-style: none;
    }
    .item {
      min-height: 100px;
      box-sizing: border-box;
      display: block;
      padding: 16px 10px 15px 128px;
      overflow: hidden;
      position: relative;

      img {
        position: absolute;
        width: 92px;
        height: 69px;
        top: 16px;
        left: 20px;
        margin-right: 16px;
      }
      h4 {
        font-size: 16px;
        padding-top: 10px;
        color: #111e36;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        -ms-flex-align: center;
        align-items: center;
        margin-bottom: 0px;
      }
      .price {
        color: #f60;
        white-space: nowrap;

        font-family: DINAlternate-Bold;
        font-size: 15px;
      }
    }
  }
}
</style>
